import React, { Component } from "react";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import {
  getProjectUsers,
  removeProjectUser,
  updateProjectUser,
} from "../../../../services/projectService";
import { getRoles, getUsers } from "../../../../services/userService";
import CustomLoader from "../../../common/Loader";
import AddProjectUser from "./AddProjectUserDialog";
import { logActivity } from '../../../../services/utilService';

class ProjectUsers extends Component {
  state = {
    //Project_ID: this.props.Project_ID,
    Project_Users: [],
    User_Options: [],
    Roles: [],
    loading: true,
  };

  async loadUsers() {
    const { data: Project_Users } = await getProjectUsers(
      this.props.Project_ID
    );

    let { data: User_Options } = await getUsers();
    User_Options = User_Options.filter((user) => {
      return (
        Project_Users.filter((puser) => puser.User_ID === user.User_ID)
          .length !== 1
      );
    });

    this.setState({ User_Options });
    this.setState({ Project_Users });
  }

  async componentDidMount() {
    this.loadUsers();

    let { data: Roles } = await getRoles();
    Roles = Roles.filter(
      (role) => role.Role_Level !== 1 && role.Role_Level !== 999
    );
    this.setState({ Roles });
    this.setState({ loading: false });
  }

  handleChange = async (role, idx) => {
    let Project_Users = [...this.state.Project_Users];
    const { data } = await updateProjectUser(
      Project_Users[idx].Record_ID,
      role
    );

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_USER_UPDATE_FAILED');
    } else {
      toaster('success', 'Updated');
      logActivity('/projectSettings', 'PROJECT_USER_UPDATE_SUCCESS');
      Project_Users[idx].Role_ID = role;
      this.setState({ Project_Users });
    }
  };

  handleRemove = async (rID) => {
    const { data } = await removeProjectUser(rID);
    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_USER_DELETE_FAILED');
    } else {
      let { Project_Users } = this.state;
      Project_Users = Project_Users.filter((user) => user.Record_ID !== rID);
      this.setState({ Project_Users });
      toaster('success', 'Removed');
      logActivity('/projectSettings', 'PROJECT_USER_DELETE_SUCCESS');
      window.location.reload()
    }
  };

  handleAdd = async (user, role) => {
    const { data } = await updateProjectUser(
      0,
      role,
      user,
      this.props.Project_ID
    );

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projectSettings', 'PROJECT_USER_CREATE_FAILED');
    } else {
      this.loadUsers();
      toaster('success', data);
      logActivity('/projectSettings', 'PROJECT_USER_CREATE_SUCCESS');
    }
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    const { Project_Users, Roles, User_Options } = this.state;
    return (
      <React.Fragment>
        <AddProjectUser
          Users={User_Options}
          Roles={Roles}
          handleAdd={this.handleAdd}
        />
        <table className="table table-hover table-borderless">
          <thead className="border-bottom">
            <tr>
              <th>User</th>
              <th>Username</th>
              <th>Role</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {Project_Users.map((user, idx) => (
              <tr className="border-bottom" key={"projectUser" + user.User_ID}>
                <td>{user.Name}</td>
                <td>{user.Username}</td>
                <td>
                  <select
                    className="form-control form-control-sm"
                    value={user.Role_ID}
                    onChange={(e) => this.handleChange(e.target.value, idx)}
                  >
                    {Roles.map((role) => {
                      return (
                        <option key={role.Role_ID} value={role.Role_ID}>
                          {role.Role_Name}
                        </option>
                      );
                    })}
                  </select>
                </td>
                <td>
                  <button
                    className="btn btn-outline-danger btn-sm rounded-0"
                    onClick={() => this.handleRemove(user.Record_ID)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <ToastContainer/>
      </React.Fragment>
    );
  }
}

export default ProjectUsers;
